import {PureComponent} from 'react'
import {UncontrolledCarousel} from 'reactstrap'
import PropTypes from 'prop-types'

import enedis from './logos/enedis.png'
import air_liquide from './logos/air_liquide.png'
import monoprix from './logos/monoprix.png'
import stellantis from './logos/stellantis.png'
import lvmh from './logos/lvmh.png'
import servier from './logos/servier.png'

import './References.scss'

const references = [
  {imgAlt: 'La société Enedis fait appel à nos services !', imgSrc: enedis},
  {imgAlt: 'La société Air Liquide fait appel à nos services !', imgSrc: air_liquide},
  {imgAlt: 'La société Monoprix fait appel à nos services !', imgSrc: monoprix},
  {imgAlt: 'La société Stellantis fait appel à nos services !', imgSrc: stellantis},
  {imgAlt: 'La société Servier fait appel à nos services !', imgSrc: servier},
  {imgAlt: 'La société LVMH fait appel à nos services !', imgSrc: lvmh},
]

export default class References extends PureComponent {
  static propTypes = {
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  render() {
    return <section className={`references ${this.props.className}`}>
      <h2 className="mb-4">Ils nous font confiance</h2>
      <div className="row d-none d-md-flex justify-content-center align-items-center py-5">
        {references.map(reference => (
          <div className="img-wrapper" key={reference.imgAlt}>
            <img className="w-100" alt={reference.imgAlt} src={reference.imgSrc}/>
          </div>
        ))}
      </div>
      <UncontrolledCarousel
        className="d-md-none"
        controls={true}
        indicators={true}
        items={references.map(reference => (
          {altText: reference.imgAlt, caption: reference.imgAlt, src: reference.imgSrc.src}
        ))}
      />
    </section>
  }
}
